import React, { Component } from 'react';

import CustomFormSF from './CustomFormSF';

import MailchimpSubscribe from 'react-mailchimp-subscribe';

import ReadMore from '../../components/Pages/ReadMore';

const url =
    'https://friendsagency.us4.list-manage.com/subscribe/post?u=9f128d945a87c7870516d5ee2&amp;id=830db8699a';

export default class SingleContact extends Component {
    constructor(props) {
        super(props);
        this.state = {
            focus: false,
        };
    }

    getBlogHeader() {
        return (
            <div>
                <header id="detail-header" className="header-nocover">
                    <div className="entry-title">
                        <h1>{this.props.title}</h1>
                    </div>
                </header>
            </div>
        );
    }

    SimpleForm() {
        return (
            <MailchimpSubscribe
                url={url}
                render={({ subscribe, status, message }) => (
                    <CustomFormSF
                        status={status}
                        message={message}
                        onValidated={formData => subscribe(formData)}
                    />
                )}
            />
        );
    }

    render() {
        return (
            <div className={`inner-container`}>
                <div className="header-blog">
                    <div className="two-col">{this.getBlogHeader()}</div>
                    <div className="two-col">
                        <div
                            className="entry-content intro"
                            dangerouslySetInnerHTML={{
                                __html: this.props.content,
                            }}
                        />
                        <a
                            className="cta-btn black"
                            href="mailto:hello@friendsagency.com">
                            Send a mail
                        </a>
                    </div>
                </div>
                <div className="clearfix" />
                <div className="inner-content">
                    <div className="two-col">
                        <img
                            src={this.props.acf.image_upload.sizes.img_contact}
                            alt="img contact"
                        />
                        <div
                            className="content"
                            dangerouslySetInnerHTML={{
                                __html: this.props.acf.custom_textfield,
                            }}
                        />
                    </div>
                    <div className="two-col">
                        <img
                            src={
                                this.props.acf.image_upload_adam.sizes
                                    .img_contact
                            }
                            alt="img contact"
                        />
                        <div
                            className="content"
                            dangerouslySetInnerHTML={{
                                __html: this.props.acf.custom_textfield_adam,
                            }}
                        />
                    </div>
                </div>
                <div className="clearfix" />
                <div className="inner-content">
                    <div className="mc-form">{this.SimpleForm()}</div>
                    <p className="mc-privacy">
                        Please see our{' '}
                        <a href="/privacy-statement">privacy policy</a>
                    </p>
                </div>
                <div>
                    <ReadMore
                        moreLeft={this.props.acf.readmore_left}
                        moreRight={this.props.acf.readmore_right}
                    />
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Pages/SingleContact.jsx